<template>
	<div>
		<v-list-item
			style="border-left: 4px solid; min-height: 60px !important"
			:style="{ 'border-left-color': getStatusPlace }"
			@click="showDialog()"
		>
			<v-list-item-avatar v-if="$vuetify.breakpoint.smAndUp" class="my-0 py-0">
				<v-icon x-small class="mr-2">mdi-home-group</v-icon>
			</v-list-item-avatar>
			<v-row justify="start" align="center">
				<v-col cols="8" sm="10" md="8" class="py-0 my-0 text-left">
					<div class="">
						{{ selectedPlace.name }} ({{
							selectedPlace.type && $vuetify.breakpoint.smAndUp
								? selectedPlace.type
								: 'No definido'
						}}) -
						<span>
							{{ $vuetify.breakpoint.smAndUp ? selectedPlace.direction : '' }}
						</span>
					</div>
					<span v-if="sharedPlace" class="subtitle-expand">
						De {{ selectedPlace.owner }}
					</span>
					<span v-if="!selectedPlace.services.length" class="caption error--text">
						Sin servicios
					</span>
				</v-col>
				<v-col class="text-right py-0 my-0">
					<span>
						<v-dialog v-model="dialogPassword" persistent max-width="400">
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" depressed text color="secondary" v-on="on">
									<v-icon small> mdi-key </v-icon>
									<span class="pt-2 title">***</span>
								</v-btn>
							</template>
							<v-card>
								<v-card-title class="primary">
									<span class="title white--text">
										Contraseñas del establecimiento</span
									>
									<v-spacer></v-spacer>
									<v-btn color="white" icon @click="dialogPassword = false">
										<v-icon>
											mdi-close
										</v-icon>
									</v-btn>
								</v-card-title>
								<v-card-text v-if="selectedPlace.name" class="pb-0">
									<v-text-field
										outlined
										filled
										dense
										class="mt-4"
										:value="selectedPlace.password"
										@change="e => (password = e)"
										:hint="
											`Sugerencia ${selectedPlace.name
												.toLowerCase()
												.replace(/\s+/g, '')} + 6 caracteres`
										"
										persistent-hint
										label="Contraseña asistencia"
									></v-text-field>
									<v-text-field
										outlined
										filled
										dense
										:value="selectedPlace.passwordDocuments"
										@change="e => (passwordDocuments = e)"
										:hint="
											`Sugerencia ${selectedPlace.name
												.toLowerCase()
												.replace(/\s+/g, '')} + 6 caracteres`
										"
										persistent-hint
										label="Contraseña Documentos"
									></v-text-field>
								</v-card-text>
								<v-card-actions>
									<v-btn
										:loading="loadingPassword"
										class="primary"
										small
										rounded
										block
										@click="setPassword"
									>
										Guardar
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
						<template v-if="itsDue">
							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="warning" v-on="on" v-bind="attrs">
										mdi-clock-alert-outline
									</v-icon>
								</template>
								<span>Tiene algun documento vencido</span>
							</v-tooltip>
						</template>
						<template v-else-if="hasPendingOrHasDocs">
							<template
								v-if="
									selectedPlace.typeDocuments.some(
										doc => doc !== null && doc.done === false
									)
								"
							>
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<v-icon small color="warning" v-on="on" v-bind="attrs">
											mdi-file-question-outline
										</v-icon>
									</template>
									<span>Documentos pendientes</span>
								</v-tooltip>
							</template>
							<template v-else>
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<v-icon small color="success" v-on="on" v-bind="attrs">
											mdi-checkbox-marked-circle-outline
										</v-icon>
									</template>
									<span>Documentos al día</span>
								</v-tooltip>
							</template>
						</template>
					</span>
					<span>
						<v-dialog v-model="dialog" persistent max-width="800">
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" icon color="secondary" v-on="on">
									<v-icon small>
										mdi-map-marker-radius
									</v-icon>
								</v-btn>
							</template>
							<v-toolbar class="title" dense flat text>
								Geocerca: {{ address }}
								<v-spacer></v-spacer>
								<v-btn icon @click="dialog = false">
									<v-icon small>
										mdi-close
									</v-icon>
								</v-btn>
							</v-toolbar>
							<geofence
								:id-map="idMap"
								:place="selectedPlace"
								:id-place="selectedPlace._id"
								:setAddress="setAddress"
							/>
						</v-dialog>
					</span>
				</v-col>
			</v-row>
			<v-bottom-sheet
				v-model="dialogNotify"
				scrollable
				inset
				@click:outside="dialogNotify = false"
			>
				<v-card>
					<v-card-text style="height: max-content" class="px-1">
						<v-tabs v-model="tab">
							<v-tab class="overline">Detalles</v-tab>
							<v-tab class="overline">Documentos</v-tab>
						</v-tabs>
						<v-tabs-items v-model="tab">
							<v-tab-item>
								<v-card outlined>
									<v-card-text>
										<details-place :place="{ ...selectedPlace }" />
									</v-card-text>
								</v-card>
							</v-tab-item>
							<v-tab-item>
								<v-card outlined>
									<v-card-text>
										<place-documents :place="selectedPlace" />
									</v-card-text>
								</v-card>
							</v-tab-item>
						</v-tabs-items>
						<div>
							<unlink-button v-if="sharedPlace" :place-id="selectedPlace._id" />
							<v-btn
								v-if="!sharedPlace"
								:loading="loadingDeletePlace"
								block
								class="my-4"
								color="accent"
								@click.stop="dialogConfirmDelete = true"
							>
								Eliminar establecimiento
							</v-btn>
							<dialog-confirm
								title="Estas seguro de eliminar"
								:dialog="dialogConfirmDelete"
								:close="() => (dialogConfirmDelete = false)"
								:confirm="() => removePlace()"
							/>
						</div>
					</v-card-text>
				</v-card>
			</v-bottom-sheet>
		</v-list-item>
		<v-divider />
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
	name: 'PlaceItem',
	components: {
		DetailsPlace: () => import('@/components/place/DetailsPlace'),
		DialogConfirm: () => import('@/components/ui/DialogConfirm'),
		Geofence: () => import('@/components/place/Geofence'),
		PlaceDocuments: () => import('@/components/place/PlaceDocuments'),
		UnlinkButton: () => import('@/components/place/UnlinkButton'),
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			dialogConfirmDelete: false,
			dialogNotify: false,
			dialogPassword: false,
			idMap: 0,
			dialog: false,
			tab: null,
			selectedPlace: {
				services: [],
				documents: [],
				typeDocuments: [],
				lodgings: [],
			},
			address: '',
			password: '',
			loadingPassword: false,
			passwordDocuments: '',
			loadingDeletePlace: false,
		};
	},
	computed: {
		totalOTs() {
			let totalOT = 0;
			if (this.selectedPlace) {
				if (this.selectedPlace.lodgings)
					if (this.selectedPlace.lodgings.length)
						this.selectedPlace.lodgings.forEach(
							lod => (totalOT += lod.workOrder.length)
						);
			}
			return totalOT;
		},
		colorSubtitle() {
			if (this.sharedPlace) {
				return 'info--text';
			}
			return 'success--text';
		},
		subtitle() {
			if (this.sharedPlace) {
				return 'Establecimiento compartido';
			}
			return 'Establecimiento creado';
		},
		sharedPlace() {
			return this.selectedPlace.ownerEmail !== this.userProfile.email;
		},
		itsDue() {
			if (this.hasPendingOrHasDocs) {
				return this.selectedPlace.documents.some(doc => {
					if (doc !== null) return moment(doc.date).isBefore(moment().format());
				});
			}
			return false;
		},
		hasPendingOrHasDocs() {
			return (
				Array.isArray(this.selectedPlace.typeDocuments) &&
				this.selectedPlace.typeDocuments.length &&
				this.selectedPlace.typeDocuments.some(typeDocument => typeDocument)
			);
		},
		getStatusPlace() {
			if (
				Array.isArray(this.selectedPlace.documents) &&
				!this.selectedPlace.documents.length &&
				Array.isArray(this.selectedPlace.typeDocuments) &&
				this.selectedPlace.typeDocuments.length
			) {
				return 'red';
			} else {
				if (this.itsDue) return 'orange';
				else if (
					this.hasPendingOrHasDocs &&
					this.selectedPlace.typeDocuments.some(doc => doc && !doc.done)
				)
					return 'orange';
				else return 'green';
			}
		},
		todayLodgings() {
			const today = moment();
			if (this.selectedPlace.lodgings) {
				let todayLodgings = this.selectedPlace.lodgings.filter(lodging => {
					const startDate = moment(lodging.start);
					const endDate = moment(lodging.end);
					return (
						today.isBetween(startDate, endDate, 'day') ||
						today.isSame(startDate, 'day') ||
						today.isSame(endDate, 'day')
					);
				});
				return todayLodgings.length;
			}

			return 0;
		},
	},
	watch: {
		item(newVal) {
			this.selectedPlace = { ...newVal };
		},
		dialog() {
			this.idMap = (Math.random() * 100).toFixed();
		},
	},
	mounted() {
		this.idMap = (Math.random() * 100).toFixed();
		this.selectedPlace = { ...this.item };
		this.address = this.selectedPlace.address;
	},
	methods: {
		showDialog() {
			this.dialogNotify = true;
		},
		setAddress(address) {
			this.address = address;
		},
		async removePlace() {
			this.dialogConfirmDelete = false;
			this.loadingDeletePlace = true;
			await this.deletePlace(this.selectedPlace._id);
			this.loadingDeletePlace = false;
		},
		async setPassword() {
			this.loadingPassword = true;
			this.updatePasswordPlace({
				id: this.selectedPlace._id,
				password: this.password,
				passwordDocuments: this.passwordDocuments,
			});
			this.loadingPassword = false;
			this.dialogPassword = false;
		},
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
		...mapActions({
			deletePlace: 'Place/deletePlace',
			updatePasswordPlace: 'Place/updatePasswordPlace',
		}),
	},
};
</script>

<style lang="scss" scoped>
.widthMaxContent {
	width: 100%;
	margin-right: 10px;
}
</style>
